(() => {
  const initialise = (root) => {
    root.querySelectorAll('[data-cosy-product]').forEach((section) => {
      if (section.dataset.initialised === 'true') return;
      section.dataset.initialised = 'true';
      const form = section.querySelector('[data-cosy-form]');
      const catalogue = JSON.parse(section.querySelector('[data-cosy-json]').textContent);
      const variants = (catalogue.variants || []).map((v) => ({...v, option1:v.option1 || v.options?.[0], option2:v.option2 || v.options?.[1]}));
      const words = JSON.parse(section.querySelector('[data-cosy-i18n]').textContent);
      const button = section.querySelector('[data-add-button]');
      const status = section.querySelector('[data-status]');
      const ready = section.dataset.ready === 'true';
      const currency = section.dataset.currency || 'GBP';
      const money = (n) => new Intl.NumberFormat('en-GB', {style:'currency', currency}).format(n / 100);
      const main = section.querySelector('[data-main-image]');
      let selected;
      const setImage = (url, alt) => {
        main.src = url;
        if (alt) main.alt = alt;
        section.querySelectorAll('[data-image]').forEach((b) => b.setAttribute('aria-pressed', String(b.dataset.image === url)));
      };
      section.querySelectorAll('[data-image]').forEach((b) => b.addEventListener('click', () => setImage(b.dataset.image, b.dataset.alt)));
      const update = (changeImage = true) => {
        const bundle = form.querySelector('input[name="cosy_offer"]:checked').value === 'bundle';
        section.querySelector('[data-single-colours]').hidden = bundle;
        section.querySelector('[data-bundle-colours]').hidden = !bundle;
        const colour = bundle ? section.querySelector('[data-bundle-select]').value : form.querySelector('input[name="cosy_colour"]:checked').value;
        const offer = bundle ? 'Buy 2, get 1 free' : 'Single wrap';
        selected = variants.find((v) => v.option1 === offer && v.option2 === colour);
        const price = selected ? selected.price : Number(bundle ? section.dataset.bundle : section.dataset.single);
        section.querySelector('[data-variant-id]').value = selected ? selected.id : '';
        section.querySelector('[data-current-price]').textContent = money(price);
        document.querySelectorAll('[data-sticky-price]').forEach((n) => n.textContent = money(price));
        button.disabled = !ready || !selected || !selected.available;
        section.querySelector('[data-button-copy]').textContent = !ready ? words.coming : (!selected || !selected.available) ? words.sold : words.add;
        status.textContent = '';
        if (changeImage) {
          const grey = colour === 'Grey' || colour === '3 Grey';
          setImage(grey ? section.dataset.grey : section.dataset.beige, grey ? 'Grey zip-front heated wearable blanket' : 'Beige zip-front heated wearable blanket');
        }
      };
      form.addEventListener('change', () => update(true));
      document.querySelectorAll('[data-choose-bundle]').forEach((link) => link.addEventListener('click', () => {
        form.querySelector('input[name="cosy_offer"][value="bundle"]').checked = true;
        update(false);
      }));
      const requested = new URLSearchParams(location.search).get('variant');
      const matching = variants.find((v) => String(v.id) === requested);
      if (matching) {
        const bundle = matching.option1 === 'Buy 2, get 1 free';
        form.querySelector(`input[name="cosy_offer"][value="${bundle ? 'bundle' : 'single'}"]`).checked = true;
        if (bundle) section.querySelector('[data-bundle-select]').value = matching.option2;
        else {
          const colourInput = Array.from(form.querySelectorAll('input[name="cosy_colour"]')).find((n) => n.value === matching.option2);
          if (colourInput) colourInput.checked = true;
        }
      }
      update(Boolean(matching));
      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        if (!ready || !selected || !selected.available) return;
        button.disabled = true;
        section.querySelector('[data-button-copy]').textContent = words.adding;
        try {
          const base = section.dataset.root || '/';
          const response = await fetch(base + 'cart/add.js', {method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:selected.id,quantity:1}]})});
          const result = await response.json();
          if (!response.ok) throw new Error(result.description || words.error);
          location.assign(base + 'cart');
        } catch (error) {
          status.textContent = error.message || words.error;
          button.disabled = false;
          section.querySelector('[data-button-copy]').textContent = words.add;
        }
      });
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initialise(document));
  else initialise(document);
  document.addEventListener('shopify:section:load', () => initialise(document));
})();
